<template>
  <div class="contractor_registered contain">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupSuccess v-if="popup=='success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup=='error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="form_input flex" v-for="(field,index) in formField" :key="index">
      <label :class="checkOK.includes(field.name)?'label_must_error':''">
        {{field.name}}
        <span v-if="field.must">*</span>
      </label>
      <!-- 部門選項 -->
      <div class="el_elment" v-if="field.val=='department'">
        <el-select v-model="formInput.department" placeholder="choose">
          <el-option
            v-for="item in options.department"
            :key="item.departmentno"
            :label="item.departmentname"
            :value="item.departmentno"
          ></el-option>
        </el-select>
      </div>
      <!--switch-->
      <div v-else-if="field.type=='switch'">
        <el-switch
          v-model="formInput[field.val]"
          :active-text="field.switchText[0]"
          :inactive-text="field.switchText[1]"
        ></el-switch>
      </div>
      <div v-else>
        <!-- 其他 -->
        <input
          type="text"
          class="input_primary"
          :placeholder="field.placeholder"
          v-model="formInput[field.val]"
        />
      </div>
    </div>
    <div class="verification_block flex">
      <Verification ref="verification"></Verification>
    </div>
    <div class="register_btn">
      <button class="btn_light" @click="enter">資料送出</button>
      <button class="btn_gray" @click="returnLogin">返回</button>
    </div>
  </div>
</template>

<style lang="scss">
.el-date-picker__header {
  display: flex;
  align-items: center;
}
.contractor_registered {
  margin: 30px;
  text-align: left;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 25px -10px rgba($color: #000000, $alpha: 0.5);
  .form_input {
    flex-wrap: wrap;
    white-space: nowrap;

    label {
      flex: 3;
      font-weight: bold;
      span {
        color: var(--subColor);
      }
    }
    > div {
      flex: 7;
      input,
      textarea {
        width: 100%;
      }
    }
  }
  .verification_block {
    border-top: 1px dashed #ccc;
    padding-top: 15px;
    margin-top: 40px;
    justify-content: flex-end;
  }
}
.form_input {
  align-items: center;
  font-size: 15px;
  margin: 15px 0;
  label {
    &.label_must_error {
      color: var(--subColor);
    }
  }

  .el_elment {
    flex: 7;
    width: 100%;
    .el-select {
      width: 100%;
    }

    .el-date-editor.el-input,
    .el-input {
      width: 100%;
      .el-input__prefix {
        display: none;
      }
      input {
        padding: 8px 10px;
        border-radius: 5px;
        background: #e5e5e5;
        border: 1px solid #e5e5e5;
        box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.2) inset;
        &:hover,
        &:focus {
          background: #fff;
          border: 1px solid #e5e5e5;
          box-shadow: none;
        }
        /*webkit瀏覽器專用*/
        &::-webkit-input-placeholder {
          color: #b6b6b6;
        }
        /*Firefox 4-18瀏覽器專用*/
        &::-moz-placeholder {
          color: #b6b6b6;
        }
        /*IE10瀏覽器專用*/
        &:-ms-input-placeholder {
          color: #b6b6b6;
        }
      }
    }
  }
}
.form_dow {
  margin: 20px 0;
  background: #f0f0f0;
  padding: 20px 10px;
  border-radius: 10px;
  .title {
    font-size: 20px;
    font-weight: bold;
  }
  .dow_btn {
    margin-top: 10px;
    justify-content: space-around;
    flex-wrap: wrap;
    button {
      margin: 3px;
      box-shadow: 10px 10px 20px -10px rgba($color: #000000, $alpha: 0.5);
      &:hover {
        box-shadow: 2px 2px 1px -1px rgba($color: #000000, $alpha: 0.5);
      }
    }
  }
}
.form_upload {
  margin: 20px 0 0 0;
  .title {
    font-size: 20px;
    font-weight: bold;
  }
  .upload_btn {
    > div {
      margin: 15px 0;
      width: 100%;
      input {
        display: none;
      }
    }
    label {
      display: block;
      font-size: 14px;
      cursor: pointer;
      padding: 12px 20px;
      width: 100%;
      text-align: center;
      border-radius: 5px;
      color: #737373;
      border: 2px dashed #ccc;
      &:hover {
        border: 2px dashed var(--mainColor);
        color: var(--mainColor);
        font-weight: bold;
      }
      .cancel_file {
        padding: 0 10px;
      }
    }
  }
}
.register_btn {
  margin: 10px 0 10px 0;
  > button {
    margin: 10px 0;
  }
  .btn_light {
    box-shadow: 10px 10px 20px -10px rgba($color: #000, $alpha: 0.4);
    &:hover {
      box-shadow: 3px 3px 5px -1px rgba($color: #000, $alpha: 0.4);
    }
  }
  .btn_border {
    border: 1px solid var(--mainColor);
    color: var(--mainColor);
  }
}
</style>

<script>
import Verification from "@/components/Verification.vue";

export default {
  name: "contractorLogin",
  data() {
    return {
      formInput: {
        department: null,
        vendor_chinese: null,
        vendor_english: null,
        license_factory: null,
        tax_id: null,
        is_foreign: false,
        owner: null,
        type: null,
        revenue_year: null,
        listed_code: null,
        company_address: null,
        factory_address: null,
        invoice_address: null,
        capital: null,
        found_date: null,
        contact_person: null,
        phone: null,
        fax: null,
        email: null,
        employee_number: null,
        license_type: null,
        bussiness_item: null,
        customer: null
      },
      formData: new FormData(),
      options: {
        license_factory: ["N6"],
        department: []
      },
      fileRegistration: null,
      fileRegistrationMark: null,
      fileEnvironment: null,
      fileSecurity: null,
      popupStatus: false,
      successText: null,
      popup: null,
      checkOK: [],
      formField: [
        {
          name: "需求單位",
          val: "department",
          placeholder: "choose",
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "供應商名稱",
          val: "vendor_chinese",
          placeholder: "中文名稱",
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "供應商名稱",
          val: "vendor_english",
          placeholder: "英文名稱",
          must: false,
          type: "input",
          switchText: null
        },
        {
          name: "外國廠商",
          val: "is_foreign",
          placeholder: null,
          must: true,
          type: "switch",
          switchText: ["是", "否"]
        },
        {
          name: "統一編號",
          val: "tax_id",
          placeholder: "登入帳號",
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "負責人",
          val: "owner",
          placeholder: null,
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "業務聯絡人",
          val: "contact_person",
          placeholder: null,
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "電話",
          val: "phone",
          placeholder: null,
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "E-mail",
          val: "email",
          placeholder: null,
          must: true,
          type: "input",
          switchText: null
        }
      ]
    };
  },
  components: {
    Verification
  },
  methods: {
    getOptions() {
      fetch("http://192.168.10.31/dcc/api/group", { method: "GET" })
        .then(res => {
          return res.json();
        })
        .then(res => {
          res.forEach(el => {
            el.departments.forEach(e => {
              this.options.department.push(e);
            });
          });
        });
    },
    registration(e) {
      this.fileRegistration = e.target.files[0].name;
      this.formData.append("business_file", e.target.files[0]); //放進上傳的檔案
    },
    registrationMark(e) {
      this.fileRegistrationMark = e.target.files[0].name;
      this.formData.append("factory_file", e.target.files[0]); //放進上傳的檔案
    },
    environment(e) {
      this.fileEnvironment = e.target.files[0].name;
      this.formData.append("safe_file", e.target.files[0]); //放進上傳的檔案
    },
    security(e) {
      this.fileSecurity = e.target.files[0].name;
      this.formData.append("information_file", e.target.files[0]); //放進上傳的檔案
    },
    cancelFile(file) {
      if (file == "registration") {
        this.fileRegistration = null;
      }
      if (file == "registrationMark") {
        this.fileRegistrationMark = null;
      }
      if (file == "environment") {
        this.fileEnvironment = null;
      }
      if (file == "security") {
        this.fileSecurity = null;
      }
    },
    returnLogin() {
      this.$router.push("/");
    },
    enter() {
      this.checkOK = [];
      //判斷必填
      this.formField.forEach(el => {
        if (el.must &&
          (this.formInput[el.val] == null || this.formInput[el.val].length == 0)) {
          //必填且欄位沒有值
          //去除掉選項是false的項目
          this.checkOK.push(el.name);
        }
      });

      if (this.checkOK.length !== 0) {
        //必填有遺漏
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請填寫:${this.checkOK.join()}`;
        //判斷文件
        //   if (
        //     !this.fileRegistration &&
        //     !this.fileRegistrationMark &&
        //     !this.fileEnvironment &&
        //     !this.fileSecurity
        //   ) {
        //     this.successText = `請填寫:${checkOK.join()}，並上傳所有文件`;
        //   }
      }

      if (this.checkOK.length == 0) {
        //必填完成
        //判斷驗證碼是否有值
        if (this.$refs.verification.fillCode) {
          let fillCode = this.$refs.verification.fillCode.toUpperCase();
          let code = this.$refs.verification.code.join("");
          //判斷驗證碼是否正確
          if (code === fillCode) {
            this.formData.append("form_input", JSON.stringify(this.formInput));

            this.$http.api.login.vendorRegister(this.formData, {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              })
              .then(res => {
                this.popupStatus = true;
                this.successText = "註冊成功";
                this.popup = "success";
                this.$router.push("/");
              })
              .catch(error => {
                this.popupStatus = true;
                this.popup = "error";
                if (error.response.status == 401) {
                  this.successText = "已經有重複註冊的統一編號存在";
                } else {
                  this.successText = "註冊失敗";
                }
              });
          } else {
            this.popupStatus = true;
            this.popup = "error";
            this.successText = `驗證碼錯誤`;
          }
        } else {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = `請填寫驗證碼`;
        }
      }
    },
    poupupEnter() {
      this.popupStatus = false;
      if (this.popup == "success") {
        this.$router.push("/");
      }
    }
  },
  mounted() {
    this.getOptions();
  }
};
</script>